import {FilterState} from "../types";
import {Reducer} from "redux";
import {DeviceListActionTypes} from "../actionTypes";
import { searchSensors, clearFilters, initialize } from '../Routines';
import { OrderFilterEnum } from "../../OrderFilterEnum";
import { AlarmFilterEnum } from "@Safemate/DeviceList/AlarmFilterEnum";


const filterState: FilterState = {
  deviceTypes: [],
  customers: [],
  alarmFilters: [],
  matchedGX8: [],
  search: "",
  maintainFilters: false,
  orderFilter: OrderFilterEnum.DEFAULT,
  userTags: [],
  wifiFilter: false
};

const filter: Reducer<FilterState> = (state = filterState, action) => {
  switch (action.type) {

    case DeviceListActionTypes.SET_FILTERS:
      return {
        ...state,
        ...action.payload
      }
        
    case DeviceListActionTypes.FILTER_DEVICE_TYPE:
      const deviceTypeState = {
        ...state,
        deviceTypes: action.payload
      }
      return deviceTypeState
    case DeviceListActionTypes.FILTER_CUSTOMER:
      const customerState = {
        ...state,
        customers: action.payload
      }
      return customerState
    case DeviceListActionTypes.FILTER_ALARM:
      const alarmState = {
        ...state,
        alarmFilters: action.payload
      }
      return alarmState
    case DeviceListActionTypes.FILTER_ORDER:
        const orderState = {
          ...state,
          orderFilter: action.payload
        }
      return orderState

    case DeviceListActionTypes.FILTER_USER_TAGS:
        const userTagsState = {
          ...state,
          userTags: action.payload
        }
      return userTagsState;
    case DeviceListActionTypes.FILTER_SEARCH:
      return{
        ...state,
        search: action.payload
      }

    case DeviceListActionTypes.TOGGLE_MAINTAIN_FILTER:
      return{
        ...state,
        maintainFilters: action.payload
      }

    case DeviceListActionTypes.TOGGLE_WIFI_FILTER:
      return{
        ...state,
        wifiFilter: action.payload
      }
    
    case clearFilters.SUCCESS:
      const filterState = {
        ...state,
        deviceTypes: [] as number[],
        customers: [] as number[],
        alarmFilters: [] as AlarmFilterEnum[],
        matchedGX8: [] as string[],
      }
      return filterState;
    case searchSensors.SUCCESS:
      return{
        ...state,
        matchedGX8: action.payload
      }

    default:
      return state;
  }
}; 

export default filter;
